import { useCallback } from 'react';
import { useLocalMutationsStore } from './LocalMutationsProvider';
export const useAddObjectMutation = () => {
  const store = useLocalMutationsStore();
  return useCallback(input => {
    return store.addIndividualObjectMutation(input);
  }, [store]);
};